// adminApi.js
import axios from "axios";

const CREDITREQUEST_API_SERVICE = `${process.env.REACT_APP_API_URL}/authservice/api/user-credit`;

const apiClient = axios.create({
  baseURL: CREDITREQUEST_API_SERVICE,
  withCredentials: true,
});

const creditRequestApi = {
  saveCreditPricing: (payload) => apiClient.post("/request", payload),

  getUserCredits: (email) => apiClient.get(`/get-credits?email=${email}`),
  updateUserCredits: (payload) => apiClient.put("/update", payload),
};

export default creditRequestApi;
